import shortid from 'shortid'
import Campaigns from './campaigns'
import MailLogs from './mail_logs'
import MailQueues from './mail_queues'
import Stages from './stages'
import Templates from './templates'
import Filters from './filters'
import SubstitutionTags from './substitution_tags'
import CampaignCategories from './campaign_categories'
import Auth from './auth'
import Substitutions from './substitutions'
import Contacts from './contacts'
import Applications from './applications'
import Emails from './emails'

export const API_URL = process.env.VUE_APP_API_URL

// handle rails different payload structure when empty result set
export async function normalizeRailsResponse(res) {
  if(res){
    let json = await res.json()
    return 'data' in json ? json.data : json
  }
}

export default class API {
  constructor(authToken) {
    this.authToken = authToken
    this.loadingCallback = null
    this.unauthorizedCallback = null

    this.loaders = []

    this.campaigns = new Campaigns(this)
    this.mail_logs = new MailLogs(this)
    this.mail_queues = new MailQueues(this)
    this.stages = new Stages(this)
    this.templates = new Templates(this)
    this.filters = new Filters(this)
    this.campaign_categories = new CampaignCategories(this)
    this.auth = new Auth(this)
    this.substitution_tags = new SubstitutionTags(this)
    this.substitutions = new Substitutions(this)
    this.contacts = new Contacts(this)
    this.applications = new Applications(this)
    this.emails = new Emails(this)
  }

  async request(url, init = {}, trackLoading = true) {
    let params = {
      headers: {
        'Authorization': `Bearer ${this.authToken}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      ...init
    }

    let id = shortid.generate()

    if (trackLoading) {
      this.startLoading(id)
    }

    let res = await fetch(url, params)

    if (res.status === 401) {
      this.emitUnauthorized()
    }

    if (trackLoading) {
      this.stopLoading(id)
    }

    // return the payload and the response so that it can be destructured by the caller
    return [await normalizeRailsResponse(res), res]
  }

  startLoading(id) {
    this.loaders.push(id)
    this.emitLoading()
  }

  stopLoading(id) {
    let index = this.loaders.indexOf(id)
    if (index > -1) {
      this.loaders.splice(index, 1)
    }
    this.emitLoading()
  }

  isLoading() {
    return this.loaders.length > 0
  }

  emitLoading() {
    if (this.loadingCallback) {
      this.loadingCallback(this.isLoading(), this.loaders)
    }
  }

  emitUnauthorized() {
    if (this.unauthorizedCallback) {
      this.unauthorizedCallback()
    }
  }
}
